import { render, staticRenderFns } from "./MandateDetail.vue?vue&type=template&id=b8329136&scoped=true"
import script from "./MandateDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./MandateDetail.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MandateDetail.vue?vue&type=style&index=0&id=b8329136&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8329136",
  null
  
)

export default component.exports